import { render, staticRenderFns } from "./marketplaceProductManagement.vue?vue&type=template&id=24fb52c2&scoped=true"
import script from "./marketplaceProductManagement.vue?vue&type=script&lang=js"
export * from "./marketplaceProductManagement.vue?vue&type=script&lang=js"
import style0 from "./marketplaceProductManagement.vue?vue&type=style&index=0&id=24fb52c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb52c2",
  null
  
)

export default component.exports